import {IIncident} from "../../../core/interfaces/incident";
import {BooleanForm} from "./BooleanForm";


export function MedicalAssistanceForm(props: { editMode: boolean, newIncident: IIncident, onChange: (value: boolean | null, e: any) => void }) {
    return <BooleanForm {...props} header={"Behövdes läkarvård/psykolog på grund av händelsen"} propertyName={"medicalAssistance"}
                        property={props.newIncident.medicalAssistance}/>
}